import { IconButton } from '@workramp/ui';
import styled from 'styled-components';

export const SearchContainer = styled.div`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing(1)}px;
  margin-bot: 0px;
`;

export const ClearSearchIcon = styled(IconButton)`
  position: absolute;
  right: ${({ theme }) => theme.spacing(2)}px;
  top: 50%;
  transform: translateY(-50%);
`;
